import { clearFormError, showFormError } from 'actions'
import { notification } from 'antd'
import _ from 'lodash'
import { push } from 'react-router-redux'
import { setUserState, _setFrom, _setHideLogin } from 'reducers/app'
import * as app from '../../reducers/app'
import api from '../api'
export const SAVE_MERCHANT_CODE = "save_merchant_code"

export const LOGIN_FORM = 'login'

const saveLoginInformation = token => {
  window.localStorage.setItem('app.Authorization', token)
}

const onSuccessfulLogin = (response, dispatch) => {
  dispatch(app.deleteSubmitForm(LOGIN_FORM))

  if (response.data && response.data.responseBody && response.data.responseBody.accessToken) {
    saveLoginInformation(response.data.responseBody.accessToken)

    dispatch(app.deleteSubmitForm(LOGIN_FORM))
    dispatch(clearFormError(LOGIN_FORM))

    dispatch(_setHideLogin(true))
    dispatch(push('/simulator'))
  } else {
    dispatch(showFormError(LOGIN_FORM, 'Service currently unavailable'))
  }
}

const onLoginFailure = (error, dispatch) => {
  dispatch(app.deleteSubmitForm(LOGIN_FORM))
  // Error
  if (error.response) {
    if (error.response.data) {
      dispatch(showFormError(LOGIN_FORM, error.response.data.responseMessage))
    } else {
      //default fallback
      dispatch(showFormError(LOGIN_FORM, 'Invalid username / password combo'))
    }
  } else if (error.request) {
    dispatch(showFormError(LOGIN_FORM, 'Server currently offline'))
  } else {
    // Something happened in setting up the request that triggered an Error
    dispatch(showFormError(LOGIN_FORM, 'System error'))
  }

  dispatch(_setFrom(''))
}

export const initLogin = () => dispatch => {
  const authorization = window.localStorage.getItem('app.Authorization')
  if (authorization) {
    dispatch(push('/simulator'))
  }
}

//logs out a user and deletes all role data
export const logout = () => dispatch => {
  // dispatch(
  //   setUserState({
  //     userState: {},
  //   }),
  // )
  // window.localStorage.setItem('app.Authorization', '')
  // dispatch(push('/login'))
}

export const goToSimulatorHome = () => dispatch => {
  dispatch(push("/simulator"))
}
//util function called to check if user has access to roles required to show page
export const initAuth = () => dispatch => {
  //check if user is logged in
  return Promise.resolve(true)
}

export const login = ({ username, password, merchantCode }) => dispatch => {
  //add the submit form
  window.localStorage.setItem('app.merchantCode', merchantCode)
  dispatch({ type : SAVE_MERCHANT_CODE, payload : merchantCode })
  dispatch(app.addSubmitForm(LOGIN_FORM))
  //remove all form errors
  dispatch(clearFormError(LOGIN_FORM))

  //call login api
  dispatch(
    api.post(
      '/auth/login',
      { username, password },
      response => onSuccessfulLogin(response, dispatch),
      error => {
        onLoginFailure(error, dispatch)
      },
      true,
      { auth: { username, password } },
    ),
  )
}



// WEBPACK FOOTER //
// ./src/actions/auth/index.js